"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ButtonSwitch.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonSwitch = function ButtonSwitch(_ref) {
  var options = _ref.options,
      selected = _ref.selected,
      disabled = _ref.disabled,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-button-switch ".concat(disabled ? 'disabled' : '')
  }, options.map(function (option, key) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      tabIndex: key,
      className: " gcl-button-switch-option ".concat(selected && selected.value === option.value ? 'selected' : '', "  ").concat(disabled ? 'disabled' : ''),
      key: option.value,
      onClick: function onClick() {
        return !disabled ? onChange(option) : null;
      }
    }, option.label);
  }));
};

ButtonSwitch.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })),
  selected: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  }),
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool
};
ButtonSwitch.defaultProps = {
  options: [],
  disabled: false
};
var _default = ButtonSwitch;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/ButtonSwitch/ButtonSwitch.js
// module id = 1887
// module chunks = 0